import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  noDataAvailable: () => __(translations.masterProductStats.noDataAvailable, 'Not enough data'),
  sales: () => __(translations.masterProductStats.sales, 'Sales'),
  turnover: () => __(translations.masterProductStats.turnover, 'Turnover'),
  total: () => __(translations.masterProductStats.total, 'Total :'),
};
